export default "__VITE_ASSET__77753b87__"